import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

export const InspirationLayerRotationSchema = z.enum([
  'horizontal',
  'vertical',
  'diagonal-left',
  'diagonal-right',
]);

export type LayerRotation = z.infer<typeof InspirationLayerRotationSchema>;

export const InspirationProjectLayerSchema = z.object({
  componentId: z.string(),
  materialId: z.nullable(z.string()),
  rotation: z.optional(InspirationLayerRotationSchema),
});

export const InspirationProjectSchema = z.object({
  id: z.string(),
  userId: z.string(),
  projectName: z.string(),
  isPublic: z.boolean(),
  type: z.literal('inspiration'),
  inspirationId: z.string(),
  initialHarmonyIds: z.optional(z.array(z.string())),
  variants: z.array(z.array(InspirationProjectLayerSchema)),
  projectThumbnail: z.optional(z.url()),
  parentId: z.optional(z.string()),
  schoolClassId: z.optional(z.string()),
  schoolClassIds: z.optional(z.array(z.string())),
});

export type InspirationProjectLayer = z.infer<
  typeof InspirationProjectLayerSchema
>;

export type InspirationProject = z.infer<typeof InspirationProjectSchema>;

export const LegacyInspirationProjectSchema = z.object({
  id: z.string(),
  userId: z.string(),
  isLegacy: z.literal(true),
  type: z.literal('legacy-inspiration'),
  projectName: z.string(),
  isPublic: z.boolean(),
  viewCount: z.number(),
  components: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  variants: z.array(
    z.array(
      z.object({
        objectId: z.string(),
        materialId: z.nullable(z.string()),
      }),
    ),
  ),
  projectThumbnail: z.optional(z.url()),
  parentId: z.optional(z.string()),
  schoolClassId: z.optional(z.string()),
  schoolClassIds: z.optional(z.array(z.string())),
});

export type LegacyInspirationProject = z.infer<
  typeof LegacyInspirationProjectSchema
>;

export const UpsertInspirationProjectResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: InspirationProjectSchema,
});

export const GetInspirationProjectResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(InspirationProjectSchema),
});

export const GetLegacyInspirationProjectResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(LegacyInspirationProjectSchema),
});
